import { Form} from "react-bootstrap";
import { Dispatch, SetStateAction } from "react";
import { ICoordsWithNameData } from "../../../dto/converters/ICoordsWithNameData";

const HelmLocalLocationsSelect = (props: {setFormData: Dispatch<SetStateAction<{dirLocalToLest: boolean, location: string, inputData: ICoordsWithNameData[]}>>, formData: {dirLocalToLest: boolean, location: string, inputData: ICoordsWithNameData[]}}) => {
    
    const setFormData = props.setFormData;
    const formData = props.formData;

    return (
        <>
            <Form.Select onChange={e => setFormData({ ...formData, location: e.target.value })}>
                <option value="1">1. Harjumaa - Aegna</option>
                <option value="2">2. Harjumaa - Aegviidu</option>
                <option value="3">3. Harjumaa - Aruküla</option>
                <option value="4">4. Harjumaa - Jüri</option>
                <option value="5">5. Harjumaa - Kehra</option>
                <option value="6">6. Harjumaa - Keila</option>
                <option value="7">7. Harjumaa - Kose</option>
                <option value="8">8. Harjumaa - Kostivere</option>
                <option value="9">9. Harjumaa - Kuusalu</option>
                <option value="10">10. Harjumaa - Lagedi</option>
                <option value="11">11. Harjumaa - Loksa</option>
                <option value="12">12. Harjumaa - Maardu</option>
                <option value="13">13. Harjumaa - Oru</option>
                <option value="14">14. Harjumaa - Paldiski</option>
                <option value="15">15. Harjumaa - Raasiku</option>
                <option value="16">16. Harjumaa - Saku</option>
                <option value="17">17. Harjumaa - Saue</option>
                <option value="18">18. Harjumaa - Tabasalu</option>
                <option value="19">19. Harjumaa - Tallinn</option>
                <option value="20">20. Harjumaa - Vaida</option>
                <option value="21">21. Harjumaa - Vasalemma</option>
                <option value="22">22. Harjumaa - Ääsmäe</option>
                <option value="23">23. Hiiumaa - Käina</option>
                <option value="24">24. Hiiumaa - Kärdla</option>
                <option value="25">25. Ida-Virumaa - Ahtme</option>
                <option value="26">26. Ida-Virumaa - Alajõe</option>
                <option value="27">27. Ida-Virumaa - Aseri</option>
                <option value="28">28. Ida-Virumaa - Iisaku</option>
                <option value="29">29. Ida-Virumaa - Jõhvi</option>
                <option value="30">30. Ida-Virumaa - Kaevanduse (Eesti Põlevkivi 1973.a.)</option>
                <option value="31">31. Ida-Virumaa - Karjamaa-Smolnitsa</option>
                <option value="32">32. Ida-Virumaa - Kiviõli</option>
                <option value="33">33. Ida-Virumaa - Kohtla-Järve - Ahtme linnaosa</option>
                <option value="34">34. Ida-Virumaa - Kohtla-Järve - Järve linnaosa</option>
                <option value="35">35. Ida-Virumaa - Kohtla-Järve - Sompa linnaosa</option>
                <option value="36">36. Ida-Virumaa - Kurtna</option>
                <option value="37">37. Ida-Virumaa - Mäetaguse</option>
                <option value="38">38. Ida-Virumaa - Narva</option>
                <option value="39">39. Ida-Virumaa - Narva-Jõesuu</option>
                <option value="40">40. Ida-Virumaa - Oru</option>
                <option value="41">41. Ida-Virumaa - Püssi</option>
                <option value="42">42. Ida-Virumaa - Sillamäe</option>
                <option value="43">43. Ida-Virumaa - Sonda</option>
                <option value="44">44. Ida-Virumaa - Toila</option>
                <option value="45">45. Ida-Virumaa - Voka</option>
                <option value="46">46. Järvamaa - Ambla</option>
                <option value="47">47. Järvamaa - Aravete</option>
                <option value="48">48. Järvamaa - Imavere</option>
                <option value="49">49. Järvamaa - Järva-Jaani</option>
                <option value="50">50. Järvamaa - Koeru</option>
                <option value="51">51. Järvamaa - Oisu</option>
                <option value="52">52. Järvamaa - Paide</option>
                <option value="53">53. Järvamaa - Peetri</option>
                <option value="54">54. Järvamaa - Roosna-Alliku</option>
                <option value="55">55. Järvamaa - Türi</option>
                <option value="56">56. Järvamaa - Väätsa</option>
                <option value="57">57. Jõgevamaa - Jõgeva</option>
                <option value="58">58. Jõgevamaa - Mustvee</option>
                <option value="59">59. Jõgevamaa - Pisisaare</option>
                <option value="60">60. Jõgevamaa - Põltsamaa</option>
                <option value="61">61. Jõgevamaa - Torma</option>
                <option value="62">62. Lääne-Virumaa - Haljala</option>
                <option value="63">63. Lääne-Virumaa - Kadrina</option>
                <option value="64">64. Lääne-Virumaa - Kunda</option>
                <option value="65">65. Lääne-Virumaa - Laekvere</option>
                <option value="66">66. Lääne-Virumaa - Rakke</option>
                <option value="67">67. Lääne-Virumaa - Rakvere</option>
                <option value="68">68. Lääne-Virumaa - Simuna</option>
                <option value="69">69. Lääne-Virumaa - Tamsalu</option>
                <option value="70">70. Lääne-Virumaa - Tapa</option>
                <option value="71">71. Lääne-Virumaa - Toolse piirkond</option>
                <option value="72">72. Lääne-Virumaa - Väike-Maarja</option>
                <option value="73">73. Lääne-Virumaa - Võsu</option>
                <option value="74">74. Läänemaa - Haapsalu</option>
                <option value="75">75. Läänemaa - Palivere</option>
                <option value="76">76. Läänemaa - Risti</option>
                <option value="77">77. Läänemaa - Taebla</option>
                <option value="78">78. Läänemaa - Uuemõisa</option>
                <option value="79">79. Läänemaa - Virtsu</option>
                <option value="80">80. Pärnumaa - Are</option>
                <option value="81">81. Pärnumaa - Audru</option>
                <option value="82">82. Pärnumaa - Häädemeeste</option>
                <option value="83">83. Pärnumaa - Kilingi-Nõmme</option>
                <option value="84">84. Pärnumaa - Lavassaare</option>
                <option value="85">85. Pärnumaa - Lihula</option>
                <option value="86">86. Pärnumaa - Paikuse</option>
                <option value="87">87. Pärnumaa - Pärnu</option>
                <option value="88">88. Pärnumaa - Pärnu-Jaagupi</option>
                <option value="89">89. Pärnumaa - Sindi</option>
                <option value="90">90. Pärnumaa - Tootsi</option>
                <option value="91">91. Pärnumaa - Tori</option>
                <option value="92">92. Pärnumaa - Tõstamaa</option>
                <option value="93">93. Pärnumaa - Vändra</option>
                <option value="94">94. Pärnumaa - Vändra EP</option>
                <option value="95">95. Põlvamaa - Põlva</option>
                <option value="96">96. Põlvamaa - Räpina</option>
                <option value="97">97. Raplamaa - Juuru</option>
                <option value="98">98. Raplamaa - Järvakandi</option>
                <option value="99">99. Raplamaa - Kohila</option>
                <option value="100">100. Raplamaa - Käru</option>
                <option value="101">101. Raplamaa - Lelle</option>
                <option value="102">102. Raplamaa - Rapla</option>
                <option value="103">103. Raplamaa - Vana-Vigala</option>
                <option value="104">104. Saaremaa - Kihelkonna</option>
                <option value="105">105. Saaremaa - Kuressaare</option>
                <option value="106">106. Saaremaa - Kärla</option>
                <option value="107">107. Saaremaa - Leisi</option>
                <option value="108">108. Saaremaa - Orissaare</option>
                <option value="109">109. Saaremaa - Salme</option>
                <option value="110">110. Saaremaa - Valjala</option>
                <option value="111">111. Tartumaa - Alatskivi</option>
                <option value="112">112. Tartumaa - Elva</option>
                <option value="113">113. Tartumaa - Kallaste</option>
                <option value="114">114. Tartumaa - Karkna</option>
                <option value="115">115. Tartumaa - Kõrvekula</option>
                <option value="116">116. Tartumaa - Lähte</option>
                <option value="117">117. Tartumaa - Mehikoorma</option>
                <option value="118">118. Tartumaa - Nõo</option>
                <option value="119">119. Tartumaa - Puhja</option>
                <option value="120">120. Tartumaa - Rannu</option>
                <option value="121">121. Tartumaa - Rõngu</option>
                <option value="122">122. Tartumaa - Tabivere</option>
                <option value="123">123. Tartumaa - Tartu</option>
                <option value="124">124. Tartumaa - Vara</option>
                <option value="125">125. Valgamaa - Otepää</option>
                <option value="126">126. Valgamaa - Puka</option>
                <option value="127">127. Valgamaa - Sihva</option>
                <option value="128">128. Valgamaa - Tsirguliina</option>
                <option value="129">129. Valgamaa - Tõrva</option>
                <option value="130">130. Valgamaa - Valga</option>
                <option value="131">131. Viljandimaa - Abja</option>
                <option value="132">132. Viljandimaa - Kõpu</option>
                <option value="133">133. Viljandimaa - Mustla</option>
                <option value="134">134. Viljandimaa - Mõisaküla</option>
                <option value="135">135. Viljandimaa - Karksi-Nuia</option>
                <option value="136">136. Viljandimaa - Saarepeedi</option>
                <option value="137">137. Viljandimaa - Suure-Jaani</option>
                <option value="138">138. Viljandimaa - Vastemõisa</option>
                <option value="139">139. Viljandimaa - Viljandi</option>
                <option value="140">140. Viljandimaa - Võhma</option>
                <option value="141">141. Võrumaa - Antsla</option>
                <option value="142">142. Võrumaa - Misso</option>
                <option value="143">143. Võrumaa - Vastseliina</option>
                <option value="144">144. Võrumaa - Viitina</option>
                <option value="145">145. Võrumaa - Võru</option>
            </Form.Select>
        </>
    );

}

export default HelmLocalLocationsSelect;
